import HourlyMethaneGraph from "../../../../src/components/research/hourlyMethane";
import NewYorkMethaneComponent from "../../../../src/components/research/nysMethane";
import * as React from 'react';
export default {
  HourlyMethaneGraph,
  NewYorkMethaneComponent,
  React
};